import React from 'react';
import bgImage from '../assets/bg/ucl/ucl2.webp';
import logoImage from '../assets/bg/ucl/ucl.png';
import '../App.css'; // Ensure styles are loaded

const CanTicket = () => {
  const handleTicketClick = () => {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="can-ticket-container">
      <div className="ticket-wrapper" onClick={handleTicketClick}>
        {/* Left Side - Main Content */}
        <div className="ticket-left" style={{ backgroundImage: `url(${bgImage})` }}>
          <div className="ticket-overlay"></div>
          <div className="ticket-content">
            <div className="ticket-header">
              <div className="header-left">
                  <img src={logoImage} alt="Logo UEFA Champions League" className="can-logo" />
                <div className="header-text">
                  <h2>UEFA CHAMPIONS LEAGUE</h2>
                  <h3>2025-2026</h3>
                </div>
              </div>
            </div>
            
            <div className="ticket-body">
              <div className="match-info">
                <span className="info-label">EVENTO</span>
                <span className="info-value">CHAMPIONS LEAGUE EM DIRETO</span>
              </div>
              <div className="match-info">
                <span className="info-label">ACESSO</span>
                <span className="info-value">TODOS OS JOGOS + VOD</span>
              </div>
              <div className="match-info">
                <span className="info-label">QUALIDADE</span>
                <span className="info-value">4K UHD / FHD</span>
              </div>
            </div>

            <div className="ticket-footer">
              <span className="promo-text">OBTENHA O SEU PASSE IPTV AGORA</span>
            </div>
          </div>
          <div className="ticket-left-notch"></div>
        </div>

        {/* Perforation Line */}
        <div className="ticket-divider">
          <div className="dashed-line"></div>
        </div>

        {/* Right Side - Stub */}
        <div className="ticket-right">
          <div className="ticket-right-notch"></div>
          <div className="stub-content">
            <div className="stub-code">
              {/* CSS Barcode Simulation */}
              <div className="barcode"></div>
              <span className="code-number">9824-2025-UCL</span>
            </div>
            <div className="stub-details">
              <div className="stub-row">
                <span>ENTRADA</span>
                <strong>IPTV</strong>
              </div>
              <div className="stub-row">
                <span>LUGAR</span>
                <strong>VIP</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanTicket;
